__turbopack_context__.v({
  "caption": "index-module__ZTzodW__caption",
});
